import SectionSales from './SectionSales';

export default SectionSales;
